import * as yup from 'yup'
import { yupResolver } from '@hookform/resolvers/yup'

const schema = yup
  .object({
    name: yup
      .string()
      .trim()
      .required('Name is required')
      .min(1, 'Name must be at least 1 character'),
  })
  .required()

const resAddSite = yupResolver(schema)

export default resAddSite
